
export default {
  loanOriginators: []
}
